import AdultCertLayer from './AdultCertLayer';

/**
 * @export
 * @class AdultCert
 * 성인 인증 필요 딜의 숨김 상태를 관리
 * [SDLUI-526] 이 작업으로 해당 AdultCert 컴포넌트는 사용자가 접속한 딜이 성인딜이든 아니든 무조건 init 하는 것으로 변경되었다.
 * 따라서 실제로 성인인증 레이어를 띄울지, 콜앱을 할지 등등은 이 컴포넌트 안에서 판단하여 분기해 주어야 한다.
 */
export default class AdultCert {
  constructor() {
    this.bIsAdultDeal = TMON.htStaticData.dealInfoContentsLevel !== 'NONE'; // 해당 딜이 성인딜인지 여부 (상중하 모두 포함)
    this.bIsTopMiddleDeal =
      TMON.htStaticData.dealInfoContentsLevel === 'TOP' ||
      TMON.htStaticData.dealInfoContentsLevel === 'MIDDLE'; // 해당 딜이 성인딜 중, 상중 딜인지 여부 (하 딜은 포함하지 않음)
    this.isAdultCert = TMON.htStaticData.isAdultCert; // 접속한 사용자가 성인인증을 받았는지 여부

    if (!this.bIsAdultDeal) {
      return; // 성인딜이 아닐 경우, 해당 컴포넌트에서 더 할 일이 없다. return 해주고 마무리한다.
    }

    this.checkUserStatus();
  }

  update(sStorageKey) {
    if (sStorageKey === 'openAdultCert') {
      this.showAdultCert();
    }
  }

  setEvent() {
    $('#view-adultcert [data-role=join]').on('click', this.join);
    $('#view-adultcert [data-role=login]').on('click', this.login);
  }

  clearLoginEvent() {
    $('#view-adultcert [data-role=join]').off('click');
    $('#view-adultcert [data-role=login]').off('click');
  }

  clearEvent() {
    if (this.oAdultCertLayer && this.oAdultCertLayer.clearEvent) {
      this.oAdultCertLayer.clearEvent();
    }

    this.clearLoginEvent();
  }

  join = e => {
    location.href = TMON.htLocal.htURL.www_join;
    e.preventDefault();
  };

  login = e => {
    TMON.oApp.oUtil.login(window.location.href, '', true);
    e.preventDefault();
  };

  checkUserStatus() {
    if (!this.bIsTopMiddleDeal) {
      // 성인 '하' 딜인 경우, 설령 사용자가 성인인증을 받지 않았거나, 로그인을 하지 않았어도 딜 내용을 볼 수 있어야 한다.
      // 따라서 앱에 adultType 을 전송하고 모든 프로세스를 마무리한다.
      this.callAppAdultType();
      return;
    }

    // 하 딜은 위에서 걸렀으므로, 아래 로직은 상중 딜에서만 살펴본다.
    if (!TMON.bLogin) {
      // 로그인이 되어 있지 않다면 로그인이 필요하다는 안내 페이지를 보여준다.
      this.showAdultLogin();
    } else if (!this.isAdultCert) {
      // 로그인이 되어 있다면, 성인인증을 받지 않은 사용자에 한해 성인인증을 요청한다.
      this.showAdultCert();
    }
  }

  callAppAdultType() {
    if (TMON.oApp.sPlatform === 'PW' || TMON.oApp.sPlatform === 'MW') {
      // PC, Mobile Web 은 콜앱을 할 필요가 없다.
      return;
    }
    // 모앱은 callApp 을 날려 성인인증 모달뷰를 호출한다.
    let sAdultType = '';
    const { dealInfoContentsLevel } = TMON.htStaticData;

    if (dealInfoContentsLevel === 'TOP') {
      sAdultType = 'Y';
    } else if (dealInfoContentsLevel === 'MIDDLE') {
      sAdultType = 'M';
    } else if (dealInfoContentsLevel === 'BOTTOM') {
      sAdultType = 'B';
    }
    TMON.app.callApp(
      'webview',
      'setWebProperties',
      `{ "adultType" : "${sAdultType}" }`
    );
  }

  showAdultLogin() {
    $('#view-adultcert .scene-isAdultCert').show();
    this.clearLoginEvent();
    this.setEvent();
  }

  /**
   * 성인인증 화면으로 전환하는 함수
   */
  showAdultCert() {
    if (TMON.oApp.sPlatform === 'PW') {
      // PC는 PHP 페이지를 사용
      location.href =
        TMON.htLocal.htURL.www_cert_adult_cert +
        // PHP에서 디코딩을 두번 해주고 있어 인코딩을 두번 해줘야 한다.
        encodeURIComponent(encodeURIComponent(location.href));
    } else if (TMON.oApp.sPlatform === 'MW') {
      // 모웹은 성인인증 레이어를 띄운다.
      if (!this.oAdultCertLayer) {
        this.oAdultCertLayer = new AdultCertLayer();
      }
      this.oAdultCertLayer.open();
    } else {
      this.callAppAdultType();
    }
  }
}
